require('./angulartics-ga')
module.exports = 'angulartics.google.analytics'



//////////////////
// WEBPACK FOOTER
// ./node_modules/angulartics-google-analytics/lib/index.js
// module id = 364
// module chunks = 6